/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */
import * as React from "react";
import { useFormContext } from "react-hook-form";
import styled from "styled-components";
import { Radio, RadioGroup } from "@nordcloud/gnui";
import { SidebarFormField } from "~/components/SidebarForm/SidebarFormField";
import { Request } from "~/models";

const Wrapper = styled.div`
  > div {
    display: flex;

    > div {
      width: auto;
      margin-right: 1rem;

      &:nth-child(1) {
        width: 125px;
      }
    }
  }
`;

type Props = {
  label: string;
  field:
    | "includedInBaseFee"
    | "extraChargeable"
    | "validInIaaS"
    | "validInPaaS";
  request: Request | undefined;
};

const tooltip =
  'Selecting "Default" means that this assignment will always use the value ' +
  "defined at the request level, even if it is changed in the future.";

export default function ({ label, field, request }: Props) {
  const { register, setValue } = useFormContext();

  React.useEffect(() => {
    register({ name: field });
  }, [field, register]);

  if (!request) {
    return null;
  }

  const defaultVal = request[field] ? "Yes" : "No";

  return (
    <SidebarFormField label={label} tooltip={tooltip}>
      <Wrapper>
        <RadioGroup name={field}>
          <Radio
            id={`${label}-def`}
            labelText={`Default (${defaultVal})`}
            value="null"
            onInput={() => setValue(field, null)}
          />
          <Radio
            id={`${label}-yes`}
            labelText="Yes"
            value="true"
            onInput={() => setValue(field, true)}
          />
          <Radio
            id={`${label}-no`}
            labelText="No"
            value="false"
            onInput={() => setValue(field, false)}
          />
        </RadioGroup>
      </Wrapper>
    </SidebarFormField>
  );
}
